<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <div class="card" id="orderList">
        <div
          class="mt-4 d-flex justify-content-between me-3 align-items-center mb-3"
        >
          <button
            @click="this.$router.go(-1)"
            type="button"
            class="btn btn-success add-btn me-2"
          >
            Back
          </button>
          <div class="d-flex align-items-center text-center mb-3">
            <h5 class="card-title mb-0 flex-grow-1 fw-bold text-center">
              <span class="text-warning fs-4"> Booking Details </span> -
              {{ this.ticket_id }}
            </h5>
          </div>
          <div>
            <button
              @click="ViewTicket"
              type="button"
              class="btn btn-success add-btn"
            >
              View Ticket
            </button>
          </div>
        </div>

        <div class="card-body" style="text-align: left">
          <input type="hidden" id="uid" value="" />
          <div class="row g-3">
            <div class="col-lg-3">
              <label for="ticket_id" class="form-label"
                >Ticket ID<span style="color: red">*</span></label
              >
              <input
                type="text"
                v-model="ticket_id"
                id="ticket_id"
                class="form-control"
                placeholder="Ticket ID"
                required
                disabled
              />
            </div>
            <div class="col-lg-3">
              <div>
                <label for="booking_date" class="form-label"
                  >Booking Date & Time<span style="color: red">*</span></label
                >
                <input
                  id="booking_date"
                  v-model="bookingDateAndTime"
                  class="form-control"
                  placeholder="Booking Date and Time"
                  required
                  disabled
                />
              </div>
            </div>

            <div class="col-lg-3">
              <div>
                <label for="boarding_date" class="form-label"
                  >Boarding Date & Time<span style="color: red">*</span></label
                >
                <input
                  id="boarding_date"
                  v-model="boardingDateAndTime"
                  class="form-control"
                  placeholder="Boarding Date and Time"
                  required
                  disabled
                />
              </div>
            </div>

            <div class="col-lg-3">
              <div>
                <label for="Dropping_date" class="form-label"
                  >Droping Date & Time<span style="color: red">*</span></label
                >
                <input
                  v-model="dropingDateAndTime"
                  id="Dropping_date"
                  class="form-control"
                  placeholder="Dropping Date and Time"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="from" class="form-label"
                  >From<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="from"
                  v-model="from"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="to" class="form-label"
                  >To <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="to"
                  v-model="to"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="total_km" class="form-label"
                  >Total KM travelled<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="totalDistance"
                  id="total_km"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="total_duration" class="form-label"
                  >Travel Duration in Minutes<span style="color: red"
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  v-model="totalDuration"
                  id="total_duration"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="adult" class="form-label"
                  >Adult <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="adult"
                  id="adult"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="child" class="form-label"
                  >Child <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="child"
                  id="child"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="luggage" class="form-label"
                  >Luggage in units <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="luggageInUnits"
                  id="luggage"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="seating_mode" class="form-label"
                  >Seating Mode <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="seating_mode"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="seat_no" class="form-label"
                  >Seat No <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="seat_no"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="bus_no" class="form-label"
                  >Bus No <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="bus_no"
                  v-model="busNo"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="travels_name" class="form-label"
                  >Travels Name <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="travels_name"
                  v-model="travelsName"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="conductor_name" class="form-label"
                  >Conductor Name <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="staffs.name"
                  id="conductor_name"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="conductor_name" class="form-label"
                  >Conductor Number <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="staffs.phoneNumber"
                  id="conductor_name"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="booking_type" class="form-label"
                  >Booking Type <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="booking_type"
                  v-model="bookingMethod"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="trip_status" class="form-label"
                  >Trip Status <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="tripStatus"
                  id="trip_status"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="coupon_code" class="form-label"
                  >Coupon Code <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="couponCode"
                  id="coupon_code"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="coupon_code" class="form-label"
                  >Payment ID <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="paymentID"
                  id="coupon_code"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="coupon_code" class="form-label"
                  >Payment Type <span style="color: red">*</span></label
                >
                <input
                  v-model="paymentType"
                  type="text"
                  id="coupon_code"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div>
                <label for="coupon_code" class="form-label"
                  >Payment Status <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  v-model="paymentStatus"
                  id="coupon_code"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="card" id="orderList">
        <div class="mt-4">
          <div class="d-flex align-items-center mb-3" style="text-align: left">
            <h5 class="card-title mb-0 flex-grow-1 fw-bold text-center">
              <span class="text-warning fs-4"> User Details </span> -
              {{ this.ticket_id }}
            </h5>
          </div>
        </div>

        <div class="card-body" style="text-align: left">
          <input type="hidden" id="uid" value="" />
          <div class="row g-3">
            <div class="col-lg-3">
              <label for="reg_contact" class="form-label"
                >Registered Contact<span style="color: red">*</span></label
              >
              <input
                type="text"
                v-model="regContact"
                id="reg_contact"
                class="form-control"
                required
                disabled
              />
            </div>
            <div class="col-lg-3">
              <div>
                <label for="email" class="form-label"
                  >Registered E-Mail<span style="color: red">*</span></label
                >
                <input
                  disabled
                  v-model="regEmail"
                  type="email"
                  id="email"
                  class="form-control"
                  required
                />
              </div>
            </div>

            <div class="col-lg-3">
              <div>
                <label for="primary_contact" class="form-label"
                  >Primary Passenger Contact<span style="color: red"
                    >*</span
                  ></label
                >
                <input
                  v-model="primaryContact"
                  type="text"
                  id="primary_contact"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>

            <div class="col-lg-3">
              <div>
                <label for="primary_email" class="form-label"
                  >Primary Passenger Email<span style="color: red"
                    >*</span
                  ></label
                >
                <input
                  type="email"
                  id="primary_email"
                  v-model="primaryEmail"
                  class="form-control"
                  required
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid" style="width: 75vw">
      <div class="card" id="orderList">
        <div class="mt-4">
          <div class="d-flex align-items-center" style="text-align: left">
            <h5 class="card-title mb-0 flex-grow-1 fw-bold text-center">
              <span class="text-warning fs-4"> Fare Details </span> -
              {{ this.ticket_id }}
            </h5>
          </div>
        </div>
        <div class="card" id="orderList" style="padding: 2em">
          <div class="d-flex justify-content-between mb-2">
            <span>Adult Fare (x{{ adult }})</span>
            <span>₹{{ adultFare }}</span>
          </div>

          <div class="d-flex justify-content-between mb-2">
            <span>Children Fare (x{{ child }})</span>
            <span>₹{{ childFare }}</span>
          </div>

          <div class="d-flex justify-content-between mb-2">
            <span>Luggage Charges(x{{ luggageInUnits }})</span>
            <span>₹{{ luggageFare }}</span>
          </div>

          <div class="d-flex justify-content-between text-success mb-2">
            <span>Discount</span>
            <span>- ₹{{ discountedPrice }}</span>
          </div>

          <div class="d-flex justify-content-between text-muted mb-2">
            <span>Route Bus Fee</span>
            <span>₹{{ routeBusFee }}</span>
          </div>

          <div class="d-flex justify-content-between text-muted mb-2">
            <span>Wallet Points Used</span>
            <span>₹{{ walletPointsUsed }}</span>
          </div>

          <hr />

          <div class="d-flex justify-content-between fw-bold fs-5">
            <span>Total</span>
            <span> {{ finalPrice }} </span>
          </div>

          <hr class="my-4" />

          <div class="text-center text-muted fst-italic">
            <small
              >"Travel is the only thing you buy that makes you richer."</small
            >
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loaderLoding" />
  </div>
</template>

<script>
import { getBusById } from "@/apis/busdetailsapis";
import { getCustomerById } from "@/apis/customer";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "bookingPage",
  data() {
    return {
      ticket_id: null,

      bookingDateAndTime: null,
      boardingDateAndTime: null,
      dropingDateAndTime: null,

      from: null,
      to: null,
      total_km: null,
      total_duration: null,
      adult: null,
      child: null,
      luggageInUnits: null,
      busNo: null,
      travelsName: null,
      conductorName: null,
      tripStatus: null,
      regContact: null,
      regEmail: null,
      primaryContact: null,
      primaryEmail: null,
      paymentID: null,

      discountedPrice: null,
      routeBusFee: null,
      walletPointsUsed: null,

      paymentStatus: null,
      totalPrice: null,
      couponCode: null,
      totalDuration: null,
      totalDistance: null,
      childFare: null,
      adultFare: null,
      luggageFare: null,
      finalPrice: null,
      staffs: {},

      loaderLoding: false,
    };
  },

  components: {
    Loader,
  },

  methods: {
    async getBusDetails(busID) {
      const response = await getBusById(busID);

      if (response.success) {
        this.busNo = response.data.reg_no;
        this.travelsName = response.data.travels_name;
      }
    },

    ViewTicket() {
      const ticketData = {
        ticket_id: this.ticket_id,
        bookingDateAndTime: this.bookingDateAndTime,
        boardingDateAndTime: this.boardingDateAndTime,
        dropingDateAndTime: this.dropingDateAndTime,
        from: this.from,
        to: this.to,
        total_km: this.totalDistance,
        total_duration: this.totalDuration,
        adult: this.adult,
        child: this.child,
        luggageInUnits: this.luggageInUnits,
        busNo: this.busNo,
        travelsName: this.travelsName,
        conductorName: this.conductorName,
        tripStatus: this.tripStatus,
        regContact: this.regContact,
        regEmail: this.regEmail,
        primaryContact: this.primaryContact,
        primaryEmail: this.primaryEmail,
        discountedPrice: this.discountedPrice,
        routeBusFee: this.routeBusFee,
        paymentStatus: this.paymentStatus,
        totalPrice: this.finalPrice,
        totalDistance: this.totalDistance,
        totalDuration: this.totalDuration,
        childFare: this.childFare,
        adultFare: this.adultFare,
        luggageFare: this.luggageFare,
        walletPointsUsed: this.walletPointsUsed,
      };

      localStorage.setItem("ticket_data", JSON.stringify(ticketData));

      this.$router.push({
        path: `/view_ticket/${this.ticket_id}`,
      });
    },

    async getUserById(userId) {
      const response = await getCustomerById(userId);
      if (response.success) {
        this.regContact = response.data.phone_number || "N/A";
        this.regEmail = response.data.email || "N/A";
      }
    },
  },

  async mounted() {
    this.loaderLoding = true;
    const bookingDetails = JSON.parse(localStorage.getItem("user_edit_data"));

    const {
      booking_id,
      created_at,
      boarding_time_date,
      drop_time_date,
      wallet_points_used,
      source,
      destination,
      total_adults,
      total_child,
      luggage,
      total_fare,
      bus_id,
      booking_status,
      primary_passenger_contact,
      primary_passenger_email,
      customer_id,
      discounted_price,
      wallet_used,
      route_bus_fee,
      payment_status,
      final_fare,
      booking_type,
      coupan_code,
      time_taken_minutes,
      distance_travelled,
      total_child_fare,
      total_adult_fare,
      luggage_fare,
      pay_u_referance,
      payment_type,
      staffs,
    } = bookingDetails;

    if (bookingDetails) {
      // get bus details
      this.ticket_id = booking_id;
      this.boardingDateAndTime = boarding_time_date?new Date(boarding_time_date).toLocaleString():"N/A";
      this.bookingDateAndTime = created_at?new Date(created_at).toLocaleString():"N/A";
      this.dropingDateAndTime = drop_time_date ?new Date(drop_time_date).toLocaleString():"N/A";
      this.from = source;
      this.to = destination;
      this.adult = total_adults;
      this.child = total_child;
      this.luggageInUnits = luggage;
      this.tripStatus = booking_status;
      this.primaryContact = primary_passenger_contact;
      this.primaryEmail = primary_passenger_email || "N/A";
      this.discountedPrice = discounted_price;
      this.routeBusFee = route_bus_fee;
      this.walletPointsUsed = wallet_points_used;
      (this.paymentID = pay_u_referance), (this.paymentStatus = payment_status);
      this.totalPrice = total_fare;
      this.bookingMethod = booking_type;
      this.couponCode = coupan_code ? coupan_code : "----";
      this.totalDistance = distance_travelled;
      this.totalDuration = time_taken_minutes;
      this.childFare = total_child_fare;
      this.adultFare = total_adult_fare;
      this.luggageFare = luggage_fare;
      this.finalPrice = final_fare;
      this.staffs.name = staffs[0]?.name || "N/A";
      this.staffs.phoneNumber = staffs[0]?.phone_number || "N/A";

      this.paymentType = payment_type;

      await this.getUserById(customer_id);
      await this.getBusDetails(bus_id);

      if (wallet_used) {
        console.log("fessf");
      }

      this.loaderLoding = false;
    }
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 11px;
  display: flex;
  align-items: center;
}
</style>
